import axios from "axios";

const useFormDataAPI = () => {
  const instance = axios.create({
    baseURL: process.env.REACT_APP_API_URL,
    headers: {
      authorization: `Bearer ${localStorage.getItem("accessToken")}`,
      "Content-type": "multipart/form-data"
    },
  });

  return instance;
};

export default useFormDataAPI;
